import { selectCognitoUserObject } from 'utils/cognito.util';
import { isEnvCy } from 'utils/env/determine.util';
import logger from 'utils/logger.util';
import isFn from 'utils/predicates/function/isFn.util';

import AT from './requestCode.type';

const L = logger('requestCode');

const ATTRIBUTE = 'phone_number';

// noinspection DuplicatedCode
const mockRequestCode = () => (dispatch) => {
  const data = '';

  dispatch(L.debug('mockRequestCode()', 'init:', { type: AT.init }));
  dispatch(L.debug('mockRequestCode()', 'pass:', { type: AT.pass, data }));
  dispatch(L.debug('mockRequestCode()', 'done:', { type: AT.done }));

  return Promise.resolve(data);
};

// FIXME: mocking should be part of the Cypress tests not the regular code
const requestCode = isEnvCy()
  ? mockRequestCode
  : () => (dispatch, getState) => {
      // SEE: https://www.npmjs.com/package/amazon-cognito-identity-js
      // SEE: https://github.com/aws-amplify/amplify-js

      const user = selectCognitoUserObject(getState());
      dispatch({ type: AT.init });

      const promise = new Promise((onSuccess, onFailure) => {
        try {
          if (isFn(user && user.getAttributeVerificationCode)) {
            // NOTE: needs to have null for inputVerificationCode so that onSuccess and onFailure  will be called
            user.getAttributeVerificationCode(ATTRIBUTE, { onSuccess, onFailure, inputVerificationCode: null });
          } else {
            onFailure(new Error("Can't request verification code, maybe not logged in or invalid user:", user));
          }
        } catch (e) {
          onFailure(e);
        }
      });

      promise
        .then((message) => dispatch({ type: AT.pass, data: L.debug('()', 'then()', message) }))
        .catch((e) => dispatch({ type: AT.fail, data: L.warn('()', 'catch()', { user }, e) }))
        .finally(() => dispatch({ type: AT.done }));

      return promise;
    };

// noinspection JSUnusedGlobalSymbols
export default requestCode;
